export default {
	data: () => ({
        // SHORTT_WEALTH_MAX_YEAR : 5,
        // AGGRESSIVE : "aggressive"
    }),
    methods: {
        calculateFV(rate, periods, payment, value, type){
             // Initialize type
	        type = (typeof type === 'undefined') ? 0 : type;
	        // Return future value
	        // console.log(rate+"::"+periods+"::"+payment+"::"+value+"::"+type);
	        var result;
	        if (rate === 0) {
	            result = value + payment * periods;
	        } else {
	            var rateApply = parseFloat(1) + parseFloat(rate);
	            var term = Math.pow(rateApply, periods);
	            if (type === 1) {
	                result = value * term + payment * (rateApply) * (term - parseFloat(1.0)) / rate;
	            } else {
	                result = value * term + payment * (term - parseFloat(1)) / rate;
	            }
	        }
	        return Math.abs(result);
        },
        calculatePV(rate, periods, payment, future, type){
        	type = (typeof type === 'undefined') ? 0 : type;
	        future = (typeof future === 'undefined') ? 0 : future;

	        var rateApply = parseFloat(1) + parseFloat(rate);
	        // Return present value
	        if (rate === 0) {
	            return -payment * periods - future;
	        } else {
	            return (((parseFloat(1) - Math.pow(rateApply, periods)) / rate) * payment * (rateApply * type) - future) / Math.pow(rateApply, periods);
	        }
        },
        calculatePMT(rate, periods, present, future, type){
        	// Credits: algorithm inspired by Apache OpenOffice

	        // Initialize type
	        type = (typeof type === 'undefined') ? 0 : type;
	        future = (typeof future === 'undefined') ? 0 : future;

	        // Evaluate rate and periods (TODO: replace with secure expression evaluator)
	        //rate = eval(rate);
	        //periods = eval(periods);

	        // Return payment
	        var rateApply = parseFloat(1) + parseFloat(rate);
	        var result;
	        if (rate === 0) {
	            result = (present + future) / periods;
	        } else {
	            var term = Math.pow(rateApply, periods);
	            if (type === 1) {
	                result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / rateApply;
	            } else {
	                result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
	            }
	        }
	        return -result;
        },
        validateNumber(number){

        },
        shorthandCurrency(value, showThousands){
			var val = ""+value;
			val = val.replace(new RegExp(',', 'g'), '');
			if(val >= 10000000){
				val = (val/10000000).toFixed(2) + ' Cr';
			}
			else if(val >= 100000) {
				var intermediateVal = (val/100000).toFixed(2);//*100-((val/100000).toFixed(2)*100%100);
				// console.log(intermediateVal+"::"+((intermediateVal * 100) % 100));
				if( ((intermediateVal * 100) % 100) == 0 )
					intermediateVal = ((intermediateVal*100)-(intermediateVal *100 %100))/100;
				val = (intermediateVal) + ' L';
			}
			else{ 
				if( showThousands ){
					if(val >= 10000) {
						val = val.substring(0, 2)+","+val.substring(2,value.length);
					}
					else if(val >= 1000) {
						val = val.substring(0, 1)+","+val.substring(1,value.length);
					}
				}
				else
					val="";	
			}
			return val;
		},
		commaSeparateNumber(val){
		   	val=val.toString();
			var afterPoint = '';
			if(val.indexOf('.') > 0)
			   afterPoint = val.substring(val.indexOf('.'),val.length);
			val = Math.floor(val);
			val=val.toString();
			var lastThree = val.substring(val.length-3);
			var otherNumbers = val.substring(0,val.length-3);
			if(otherNumbers != '')
			    lastThree = ',' + lastThree;
			var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
		    return res;
		},
		formatAmount(val){
			val=val.toString();
      		val = val.replace(/\,/g,"");
			return this.commaSeparateNumber(val);
		}
    }
}
